import { Box, Tab, Tabs } from '@mui/material';
import {
  Link,
  Route,
  Switch,
  useLocation,
  useRouteMatch
} from 'react-router-dom';
import { ScreenGreeting } from '../../../Components/Molecules';
import { Payments } from './tabs/payments';
import { RangeConfiguration } from './tabs/range-configuration';

const PayOffice = () => {

  const { path } = useRouteMatch();

  const location = useLocation()

  return (
    <Box>
      <ScreenGreeting
        title="Pagadoria"
        subTitle="A centralização do fluxo de pagamento de todos os seus operadores."
      />
      <Tabs value={location.pathname}>
        <Tab component={Link} to={`${path}`} value='/pay-office' label="Pagamentos" />
        <Tab component={Link} to={`${path}/range-configuration`} value='/pay-office/range-configuration' label="Configurações" />
      </Tabs>
      <Box pt={2}>
        <Switch>
          <Route exact path={path} component={Payments} />
          <Route exact path={`${path}/range-configuration`} component={RangeConfiguration} />
        </Switch>
      </Box>
    </Box>

  )
}

export { PayOffice };

